import { useEffect, useState } from 'react';
import { LFC } from '../../types';

interface DelayUnmountProps {
  delay?: number;
  unmount?: boolean;
}

export const DelayUnmount: LFC<DelayUnmountProps> = ({
  delay = 500,
  unmount,
  children,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    let timeout: NodeJS.Timeout;
    if (unmount) {
      timeout = setTimeout(() => {
        setMounted(false);
      }, delay);
    } else {
      setMounted(true);
    }
    return () => {
      clearTimeout(timeout);
    };
  }, [unmount, delay]);

  return <>{mounted && children}</>;
};
